module.exports = __webpack_public_path__ + "3e3e4cb7a30dbd0436a719d887a9b8e9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-9.png
// module id = 2133
// module chunks = 0